import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { Phone } from "lucide-react";
import { FAQS, COMPANY } from "@/data/content";

export default function FAQSection() {
  return (
    <section id="faq" className="section-pad bg-secondary" data-testid="section-faq">
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <span className="text-sm font-bold tracking-wide text-[color:var(--brand-green-alt)] uppercase">Häufige Fragen</span>
            <h2 className="mt-2 font-display text-4xl sm:text-5xl text-[color:var(--brand-navy)]">Antworten zum Hausnotruf</h2>
            <p className="mt-3 text-base text-muted-foreground">Sie haben eine Frage, die hier nicht beantwortet wird? Rufen Sie uns an – wir beraten Sie gerne persönlich.</p>
            <a
              href={`tel:${COMPANY.phoneHref}`}
              data-testid="faq-call-link"
              className="mt-5 inline-flex items-center gap-2 rounded-xl bg-[color:var(--brand-navy)] text-white px-5 py-3 font-bold hover:bg-[color:var(--brand-navy-alt)] transition-colors"
            >
              <Phone className="h-5 w-5" /> {COMPANY.phoneDisplay}
            </a>
          </div>

          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full space-y-3">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-accordion-item-${i + 1}`}
                  className="rounded-2xl border border-border bg-white px-5 card-shadow"
                >
                  <AccordionTrigger className="text-left text-base sm:text-lg font-bold text-[color:var(--brand-navy)] hover:no-underline py-5">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-[15px] leading-relaxed text-muted-foreground pb-5">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
